import {
  Avatar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  AvatarGroup,
  Hidden,
  useMediaQuery,
} from '@mui/material';
import React, { useEffect, useState, useCallback } from 'react';
import EnhancedTableHead from '../../components/DataTables/TableHead';
import CustomizedTooltips from '../../components/CustomizedTooltips';
import useStyles from './styles';
import { useTheme } from '@mui/material/styles';
import TableToolbox from '../../components/TableToolbox';
import classNames from 'classnames';
import { Strings } from '../../utils/strings';
import NewJob from './NewJob';
import {
  getDateRangeValue,
  getDuration,
  getErrorMessage,
  getFirstTwoLetter,
  isAdmin,
  isClient,
  jobsDetailTabArray,
  secondaryTableCell,
  statusColor,
  tableCell,
  userId,
} from '../../utils/appUtils';
import Tabs from '../../components/Tabs';
import { useLocation, useNavigate } from 'react-router-dom';
import JobDetails from './JobDetails';
import JobFilter from './JobFilter';
import { connect } from 'react-redux';
import {
  fetchJobList,
  setJobList,
} from '../../redux/actions/jobActions/jobActions/jobList';
import { CircularProgress } from '@material-ui/core';
import moment from 'moment';
import SendReport from './SendReport';
import { deleteJob } from '../../redux/actions/jobActions/jobActions/deleteJob';
import CommonDialog from '../../components/CommonDialog';
import { icons } from '../../utils/icons';
import { updateRecurrence } from '../../redux/actions/jobActions/jobActions/updateRecurrence';
import { cancelRecurrence } from '../../redux/actions/jobActions/jobActions/cancelRecurrence';
import { useAlert } from 'react-alert';
import TitleContainer from '../../components/TitleContainer';
import AddNotes from '../Issues/NotesDialog';
import Button from '../../components/Button';
import { deleteJobNote } from '../../redux/actions/jobActions/jobActions/deleteJobNote';
import debounce from 'lodash/debounce';
import MediaImageContainer from '../../components/MediaImageContainer';
import { listFilter } from '../../redux/actions/filterActions/listFilter';
import JobNewFilter from './JobFilter/JobNewFilter';
import { markAllJobsNotesRead } from '../../redux/actions/jobActions/jobActions/markAllJobNotesRead';
import { useDispatch } from 'react-redux';
import { setAddJobNote } from '../../redux/actions/jobActions/jobActions/addJobNote';
import { setUpdateJobNote } from '../../redux/actions/jobActions/jobActions/updateJobNote';

const filterStore = 'JobsFilter';

// ======== Table Head =========
const headCells = () => {
  return !isClient()
    ? [
        { id: 'title', label: 'TITLE', isSort: true },
        { id: 'property', label: 'PROPERTY', isSort: true },
        { id: 'startDate', label: 'START DATE', isSort: true },
        { id: 'endDate', label: 'DURATION', isSort: true },
        { id: 'jobForm', label: 'FORM', isSort: true },
        { id: 'assigned', label: 'ASSIGNED' },
        { id: 'jobStatus', label: 'STATUS', isSort: true },
        // { id: 'client', label: 'CLIENT', isSort: true },
        // { id: 'report', label: 'REPORT' },
        // { id: 'viewedByClient', label: 'VIEWED BY CLIENT' },
        { id: '' },
      ]
    : [
        { id: 'title', label: 'TITLE', isSort: true },
        // { id: 'startDate', label: 'START DATE', isSort: true },
        // { id: 'endDate', label: 'END DATE', isSort: true },
        // { id: 'jobForm', label: 'FORM', isSort: true },
        // { id: 'assigned', label: 'ASSIGNED' },
        { id: 'property', label: 'PROPERTY', isSort: true },
        { id: 'assignedMember', label: 'ASSIGNED MEMBER', isSort: false },
        { id: 'conductedOn', label: 'CONDUCTED ON', isSort: false },
        { id: 'jobStatus', label: 'STATUS', isSort: true },
        { id: 'report', label: 'REPORT' },
        { id: '' },
      ];
};

const NotesDataList = (props) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <div
      style={{
        borderBottom: !props.isBottomBorder && 'none',
        ...props.style,
      }}
    >
      <div className={classes.note_view_container}>
        <div className={classes.note_text_container}>
          <p className={classes.note_data} style={{ border: 0 }}>
            {props?.data?.note}
          </p>
          {props?.data?.createdBy?._id === userId() && (
            <div
              className={classes.note_text_container}
              style={{ marginLeft: 'auto' }}
            >
              <CustomizedTooltips title={Strings.EDIT_NOTE}>
                <img
                  className={classes.action_icons}
                  src={icons(theme).editIcon}
                  alt=''
                  onClick={() => props.onEditClick()}
                />
              </CustomizedTooltips>
              {props?.deleteLoader ? (
                <CircularProgress
                  style={{
                    color: theme.palette.background_button,
                    marginLeft: 15,
                  }}
                  size={20}
                />
              ) : (
                <CustomizedTooltips title={Strings.DELETE_NOTE}>
                  <img
                    className={classes.action_icons}
                    src={icons(theme).deleteIcon}
                    alt=''
                    onClick={() => props.onDeleteClick()}
                    style={{ marginLeft: 15 }}
                  />
                </CustomizedTooltips>
              )}
            </div>
          )}
        </div>
      </div>
      {props?.data?.createdBy && (
        <div className={classes.note_details_container}>
          <p
            className={classes.note_data}
            style={{ paddingBottom: 0, marginBottom: 0 }}
          >
            <span style={{ fontWeight: 600 }}>{Strings.CREATED_BY}: </span>
            {`${props?.data?.createdBy?.name} ( ${
              moment(props?.data?.createdAt).format('ll') + // LL - Jul 14, 2023
              ' ' +
              moment(props?.data?.createdAt).format('LT')
            } )`}
          </p>
        </div>
      )}
    </div>
  );
};

const Jobs = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [search, setSearch] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  // const [jobData, setJobData] = useState({});
  const jobData = props.jobListData || {};
  const [addJobDialog, setAddJobDialog] = useState(false);
  const [jobDetailDialog, setJobDetailDialog] = useState(false);
  const [jobFilterDialog, setJobFilterDialog] = useState(false);
  const [sendReportDialog, setSendReportDialog] = useState(false);
  const [activeTab, setActiveTab] = useState('Today');
  const alert = useAlert();
  const navigate = useNavigate();
  const [filter, setFilter] = useState(
    isAdmin() ? { showAllJob: false } : null
  );
  const [deleteJobDialog, setDeleteJobDialog] = useState(false);
  const [selectedJob, setSelectedJob] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState('');
  const [selectedJobClient, setSelectedJobClient] = useState('');
  const [addNoteDialog, setAddNoteDialog] = useState(false);
  const [openRows, setOpenRows] = useState([]);
  const [detailsActiveTab, setDetailsActiveTab] = useState([]);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');
  const [isEditNote, setIsEditNote] = useState(false);
  const [selectedNoteData, setSelectedNoteData] = useState(null);
  const [selectedJobNoteId, setSelectedJobNoteId] = useState(null);
  const mobileView = useMediaQuery(theme.breakpoints.down('sm'));
  const tabletView = useMediaQuery(theme.breakpoints.down('md'));
  const laptopView = useMediaQuery(theme.breakpoints.down('lg'));
  const [filterDropdownValue, setFilterDropdownValue] = useState('0');
  const [filterDropdownList, setFilterDropdownList] = useState([]);
  const [openEditFilterDialog, setOpenEditFilterDialog] = useState();
  const [isFilterChange, setIsFilterChange] = useState(false);

  const { state } = useLocation();
  const dispatch = useDispatch();

  const onError = (err) => {
    const error = getErrorMessage(err);
    if (error) {
      alert.error(error);
    }
  };

  const getJobList = (data) => {
    props.fetchJobList(data, (err) => onError(err));
  };

  const delayedSearch = useCallback(
    debounce(
      (data, type) => props?.fetchJobList(data, (err) => onError(err)),
      600
    ),
    []
  );

  useEffect(() => {
    if (
      (startDate &&
        moment(startDate).format('YYYY-MM-DD') !== 'Invalid date' &&
        endDate &&
        moment(endDate).format('YYYY-MM-DD') !== 'Invalid date') ||
      !startDate ||
      !endDate
    ) {
      const storedFilter = localStorage.getItem(filterStore) || {};
      let prevFilter =
        Object.keys(storedFilter).length > 0 ? JSON.parse(storedFilter) : {};

      const data = {
        searchString: search,
      };

      if (prevFilter && (prevFilter?.filterId || prevFilter?.filter)) {
        if (prevFilter?.filterId) {
          setFilterDropdownValue(prevFilter?.filterId || '0');
        }

        if (prevFilter?.filter) {
          if (prevFilter?.filter?.dateRange !== 'All Time') {
            let dateRange = getDateRangeValue(prevFilter?.filter?.dateRange);
            let filter = {
              ...prevFilter?.filter,
              startDate: moment(dateRange.startDate).format('YYYY-MM-DD'),
              endDate: moment(dateRange.endDate).format('YYYY-MM-DD'),
            };
            prevFilter = { filter: { ...filter } };
          }
          data.filter = {
            ...prevFilter?.filter,
          };
          setFilter(prevFilter?.filter);
        }
      } else {
        if (filter) data.filter = filter;
        if (
          startDate &&
          moment(startDate).format('YYYY-MM-DD') !== 'Invalid date'
        )
          data.startDate = moment(startDate).format('YYYY-MM-DD');
        if (endDate && moment(endDate).format('YYYY-MM-DD') !== 'Invalid date')
          data.endDate = moment(endDate).format('YYYY-MM-DD');
      }
      getJobList(data);
    }
  }, [
    // activeTab,
    props.addJobData,
    props.deleteJobData,
    props.updateJobData,
    props.updateRecurrenceData,
    props.cancelRecurrenceData,
    props.sendReportData,
    // props.addJobNoteData,
    // props.updateJobNoteData,
  ]);

  // useEffect(() => {
  //   const data = props.jobListData ? props.jobListData : {};
  //   setJobData(data);
  // }, [props.jobListData]);

  const setFilterData = (data) => {
    localStorage.setItem(filterStore, JSON.stringify({ filter: data }));

    if (JSON.stringify(data) === '{}' && filter) {
      setSearch('');
      setStartDate(null);
      setEndDate(null);
      setFilter(isAdmin() ? { showAllJob: false } : null);
      getJobList({});
      setFilterDropdownValue('0');
    } else if (JSON.stringify(data) !== '{}') {
      let newData = JSON.parse(JSON.stringify(data));
      // if (newData?.dateRange) delete newData.dateRange;
      setSearch('');
      setStartDate(null);
      setEndDate(null);
      setFilter(data);
      getJobList({ filter: newData });
      setFilterDropdownValue('0');
    }
  };

  const onDeleteJob = () => {
    props.deleteJob(
      selectedJob._id,
      () => setDeleteJobDialog(false),
      (err) => onError(err)
    );
  };

  const tabsArray = isClient()
    ? [
        { id: 'Today', name: 'TODAY', length: jobData?.today || 0 },
        { id: 'Upcoming', name: 'UPCOMING', length: jobData?.upcoming || 0 },
        {
          id: 'Ready for Admin Review',
          name: 'READY FOR ADMIN REVIEW',
          length: jobData?.readyForAdminReview || 0,
        },
        {
          id: 'Completed',
          name: 'COMPLETED',
          length: jobData?.completed || 0,
        },
        // {
        //   id: 'Cancelled',
        //   name: 'CANCELLED',
        //   length: jobData?.cancelled || 0,
        // },
      ]
    : [
        { id: 'Today', name: 'TODAY', length: jobData?.today || 0 },
        {
          id: 'Billing Follow Up',
          name: 'BILLING FOLLOW UP',
          length: jobData?.billingFollowUp || 0,
        },
        {
          id: 'In Progress',
          name: 'IN PROGRESS',
          length: jobData?.inProgress || 0,
        },
        {
          id: 'Ready for Admin Review',
          name: 'READY FOR ADMIN REVIEW',
          length: jobData?.readyForAdminReview || 0,
        },
        {
          id: 'Team Discussion Needed',
          name: 'Team Discussion Needed',
          length: jobData?.teamDiscussionNeeded || 0,
        },
        {
          id: 'Ready for Billing Review',
          name: 'READY FOR BILLING REVIEW',
          length: jobData?.readyForBillingReview || 0,
        },
        {
          id: 'Completed',
          name: 'COMPLETED',
          length: jobData?.completed || 0,
        },
        // {
        //   id: 'Cancelled',
        //   name: 'CANCELLED',
        //   length: jobData?.cancelled || 0,
        // },
      ];

  const setTabNotificationData = () => {
    const newData = jobData?.jobs?.map((el, ind) => {
      let internalNotes = el?.jobNotes?.filter((item) => item?.internalNotes);
      let notes = el?.jobNotes?.filter((item) => !item?.internalNotes);
      let isNotReadInternalNotes =
        internalNotes?.length > 0
          ? internalNotes?.some((elm) => !elm.isRead)
          : false;
      let isNotReadNote =
        notes?.length > 0 ? notes?.some((elm) => !elm.isRead) : false;

      return {
        key: 'details', // isClient() ? 'notes' : 'details'
        notesNotification: isNotReadNote,
        internalNotesNotification: isNotReadInternalNotes,
      };
    });
    return newData;
  };

  useEffect(() => {
    if (jobData && jobData?.jobs?.length > 0) {
      const newData = setTabNotificationData();
      setDetailsActiveTab(newData);
    }
  }, [jobData]);

  const cursor = !isClient() ? 'pointer' : 'auto';

  const onOpenRow = (rowIndex) => {
    if (openRows.findIndex((item, index) => item === rowIndex) === -1) {
      setOpenRows([...openRows, rowIndex]);
    } else {
      setOpenRows(openRows.filter((item) => item !== rowIndex));
    }
  };
  const applySortFilter = (order, orderBy, array, comparator) => {
    if (orderBy === 'jobStatus') {
      const priorities = {
        New: 1,
        'In Progress': 2,
        'Ready for Admin Review': 3,
        'Ready for Billing Review': 4,
        Completed: 5,
        Cancelled: 6,
        'Team Discussion Needed': 7,
        'Billing Follow Up': 8,
      };
      let sorted = array.sort(function (a, b) {
        if (order === 'asc') {
          return priorities[b.jobStatus] - priorities[a.jobStatus];
        } else {
          return priorities[a.jobStatus] - priorities[b.jobStatus];
        }
      });
      return sorted;
    } else {
      const stabilizedThis = array?.map((el, index) => [el, index]);
      stabilizedThis?.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
      });
      return stabilizedThis?.map((el) => el[0]);
    }
  };

  const getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };

  const descendingComparator = (a, b, orderBy) => {
    let asceding = b[orderBy] < a[orderBy];
    let descding = b[orderBy] > a[orderBy];
    if (orderBy === 'title') {
      asceding = b[orderBy]?.toLowerCase() < a[orderBy]?.toLowerCase();
      descding = b[orderBy]?.toLowerCase() > a[orderBy]?.toLowerCase();
    } else if (orderBy === 'jobForm') {
      asceding =
        b[orderBy]?.formName.toLowerCase() < a[orderBy]?.formName.toLowerCase();
      descding =
        b[orderBy]?.formName.toLowerCase() > a[orderBy]?.formName.toLowerCase();
    } else if (orderBy === 'client') {
      asceding =
        b[orderBy]?.lastName.toLowerCase() < a[orderBy]?.lastName.toLowerCase();
      descding =
        b[orderBy]?.lastName.toLowerCase() > a[orderBy]?.lastName.toLowerCase();
    } else if (orderBy === 'property') {
      asceding =
        b[orderBy]?.name.toLowerCase() < a[orderBy]?.name.toLowerCase();
      descding =
        b[orderBy]?.name.toLowerCase() > a[orderBy]?.name.toLowerCase();
    } else if (orderBy === 'startDate' || orderBy === 'endDate') {
      asceding = moment(b[orderBy]) < moment(a[orderBy]);
      descding = moment(b[orderBy]) > moment(a[orderBy]);
    }
    if (asceding) return -1;
    if (descding) return 1;
    return 0;
  };

  const handleRequestSort = (event, property) => {
    setOpenRows([]);
    const isAsc = orderBy === property && order === 'asc';
    // setDetailsActiveTab(
    //   new Array(jobData?.jobs?.length || 0).fill(
    //     isClient() ? 'notes' : 'details'
    //   )
    // );
    const newData = setTabNotificationData();
    setDetailsActiveTab(newData);
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const filteredJobs = applySortFilter(
    order,
    orderBy,
    jobData?.jobs,
    getComparator(order, orderBy, descendingComparator)
  );

  const onDeleteNoteClick = (jId, nId) => {
    props.deleteJobNote(jId, nId, onError, () => {
      const newJobsData = props.jobListData;
      const jobs = (newJobsData && newJobsData?.jobs) || [];
      const newData = jobs?.map((item) => {
        if (item?._id === jId) {
          let newJobNote = item?.jobNotes?.filter((el) => el?._id !== nId);
          item.jobNotes = newJobNote;
        }
        return item;
      });
      newJobsData.jobs = newData;
      dispatch(setJobList(newJobsData));
      setSelectedJobNoteId(null);
    });
  };

  useEffect(() => {
    !isFilterChange && !isClient() && props.listFilter('JOB', onError);
  }, []);

  useEffect(() => {
    if (!isClient()) {
      if (isFilterChange) {
        const storedFilter = localStorage.getItem(filterStore) || {};
        let prevFilter =
          Object.keys(storedFilter).length > 0 ? JSON.parse(storedFilter) : {};
        if (prevFilter?.filterId) {
          localStorage.removeItem(filterStore);
        }
        props.listFilter('JOB', onError);
        filterDropdownValue !== '0' &&
          getJobList(isAdmin() ? { filter: { showAllJob: false } } : {});
        setFilter(isAdmin() ? { showAllJob: false } : null);
        setFilterDropdownValue('0');
        setIsFilterChange(false);
      }
    }
  }, [isFilterChange]);

  useEffect(() => {
    const data = props?.listFilterData?.map((el) => ({
      title: el?.filterName,
      value: el?._id,
      filter: el.filter,
    }));
    setFilterDropdownList(data || []);
  }, [props.listFilterData]);

  const handleFilterSelectionClick = (value) => {
    if (value !== '0') {
      let filterData = filterDropdownList?.filter(
        (el) => el.value === value
      )[0];
      setFilter(filterData?.filter || {});
      localStorage.setItem(
        filterStore,
        JSON.stringify({
          filter: { ...filterData?.filter },
          filterId: value,
        })
      );
      if (filterData?.filter?.dateRange) {
        const dateRange = getDateRangeValue(filterData.filter.dateRange);
        if (filterData.filter.dateRange !== 'All Time') {
          filterData.filter.startDate = moment(dateRange.startDate).format(
            'YYYY-MM-DD'
          );
          filterData.filter.endDate = moment(dateRange.endDate).format(
            'YYYY-MM-DD'
          );
        }
      }
      getJobList(filterData?.filter ? { filter: filterData?.filter } : {});
    }
  };

  const onClickRefresh = () => {
    let data = {};
    if (filter) data.filter = filter;
    if (search) data.searchString = search;
    getJobList(data);
  };

  const onClickClearFilter = async () => {
    setSearch('');
    setFilterDropdownValue('0');
    if (isAdmin()) {
      await setFilter({ showAllJob: false });
      await getJobList({ searchString: search, filter: { showAllJob: false } });
    } else {
      await setFilter(null);
      await getJobList({ searchString: search });
    }
    await localStorage.removeItem(filterStore);
  };

  const assignedInitial = (assignedName) => {
    const initial =
      assignedName.split(' ').length > 1
        ? assignedName.split(' ')[0]?.charAt(0)?.toUpperCase() +
          assignedName.split(' ')[1]?.charAt(0)?.toUpperCase()
        : assignedName.split(' ')[0]?.charAt(0)?.toUpperCase();
    return initial;
  };

  // ===== notification related changes =====
  useEffect(() => {
    if (state && jobData?.jobs?.length > 0) {
      const fIndexOfJob = filteredJobs?.findIndex(
        (el) => el?._id === state.selectedJob
      );
      const fRowIndex = openRows?.findIndex((el) => el === fIndexOfJob);
      if (fRowIndex === -1) onOpenRow(fIndexOfJob);
      if (state?.selectedTab) {
        const newData = setTabNotificationData();
        if (fIndexOfJob !== -1) {
          newData[fIndexOfJob].key = state.selectedTab;
          let selectedTabKey =
            state?.selectedTab === 'internalNotes'
              ? 'internalNotesNotification'
              : 'notesNotification';
          newData[fIndexOfJob][selectedTabKey] = false;
          const data = {
            type: state.selectedTab,
            jobId: state.selectedJob,
          };
          props.markAllJobsNotesRead(data, onError);
        }
        setDetailsActiveTab(newData);
      }
      const elem = document.getElementById(state.selectedJob);
      elem.scroll({ left: 0, top: 0, behavior: 'smooth' });
    }
  }, [state, jobData]);

  // === clear jobList reducer data ===
  useEffect(() => {
    return () => {
      dispatch(setJobList({}));
    };
  }, []);

  // ==== when add/edit note open selectedJob and selectedTab ====
  const setAddEditNotes = async (data) => {
    if (data && Object?.keys(data)?.length > 0) {
      const newJobsData = jobData;
      const jobs = (newJobsData && newJobsData?.jobs) || [];
      const newData = jobs?.map((item) => {
        if (item?._id === selectedJobId) {
          if (selectedJobNoteId) {
            let newJobNote = item?.jobNotes?.map((el) => {
              if (el?._id === selectedJobNoteId) {
                el.note = data?.note;
                el.internalNotes = data.internalNotes;
              }
              return el;
            });
            item.jobNotes = newJobNote;
          } else {
            item.jobNotes = [data, ...item.jobNotes];
          }
        }
        return item;
      });
      newJobsData.jobs = newData;
      dispatch(setJobList(newJobsData));
      dispatch(setAddJobNote(null));
      dispatch(setUpdateJobNote(null));
      const fIndexOfJob = filteredJobs?.findIndex(
        (el) => el?._id === selectedJobId
      );
      const fRowIndex = openRows?.findIndex((el) => el === fIndexOfJob);
      if (fRowIndex === -1) onOpenRow(fIndexOfJob);
      const selectedTab = data?.internalNotes ? 'internalNotes' : 'notes';
      const tabNewData = [...detailsActiveTab];
      if (fIndexOfJob !== -1) {
        tabNewData[fIndexOfJob].key = selectedTab;
        const data = {
          type: selectedTab,
          jobId: selectedJobId,
        };
        props.markAllJobsNotesRead(data, onError);
      }
      setDetailsActiveTab(tabNewData);
      setSelectedJobNoteId(null);
      setSelectedJobId(null);
    }
  };

  useEffect(() => {
    const data = selectedJobNoteId
      ? props.updateJobNoteData || {}
      : props.addJobNoteData || {};
    if (
      data &&
      jobData?.jobs?.length > 0 &&
      (props.addJobNoteData || props.updateJobNoteData)
    ) {
      setAddEditNotes(data);
    }
  }, [jobData, props.addJobNoteData, props.updateJobNoteData]);

  return (
    <div className={classes.job_container}>
      <TitleContainer
        containerClassName={classes.title_container}
        title={isClient() ? Strings.REPORTS : Strings.JOBS}
      />
      <TableToolbox
        onClickRefresh={onClickRefresh}
        onClickClearFilter={onClickClearFilter}
        isFilter={!isClient()}
        isDate={isClient()}
        isEndDate={isClient()}
        isSearch
        search={search}
        date={startDate}
        endDate={endDate}
        isPrimaryButton
        isSecondaryButton
        onChangeSearch={(e) => {
          setSearch(e.target.value);
          setFilterDropdownValue('0');
          setFilter(isAdmin() ? { showAllJob: false } : null);
          const data = {
            searchString: e.target.value,
          };
          if (
            startDate &&
            moment(startDate).format('YYYY-MM-DD') !== 'Invalid date'
          )
            data.startDate = moment(startDate).format('YYYY-MM-DD');
          if (
            endDate &&
            moment(endDate).format('YYYY-MM-DD') !== 'Invalid date'
          )
            data.endDate = moment(endDate).format('YYYY-MM-DD');
          if (isAdmin()) data.filter = { showAllJob: false };
          // getJobList(data);
          delayedSearch(data);
        }}
        onChangeDate={(e) => {
          setStartDate(e);
          if (
            (e && moment(e).format('YYYY-MM-DD') !== 'Invalid date') ||
            (e === null && startDate)
          ) {
            setFilter(isAdmin() ? { showAllJob: false } : null);
            let data = {
              searchString: search,
            };
            if (e && moment(e).format('YYYY-MM-DD') !== 'Invalid date')
              data.startDate = moment(e).format('YYYY-MM-DD');
            if (
              endDate &&
              moment(endDate).format('YYYY-MM-DD') !== 'Invalid date'
            )
              data.endDate = moment(endDate).format('YYYY-MM-DD');
            getJobList(data);
          }
        }}
        onChangeEndDate={(e) => {
          setEndDate(e);
          if (
            (e && moment(e).format('YYYY-MM-DD') !== 'Invalid date') ||
            (e === null && endDate)
          ) {
            setFilter(isAdmin() ? { showAllJob: false } : null);
            let data = {
              searchString: search,
            };
            if (e && moment(e).format('YYYY-MM-DD') !== 'Invalid date')
              data.endDate = moment(e).format('YYYY-MM-DD');
            if (
              startDate &&
              moment(startDate).format('YYYY-MM-DD') !== 'Invalid date'
            )
              data.startDate = moment(startDate).format('YYYY-MM-DD');
            getJobList(data);
          }
        }}
        secondaryButtonText={Strings.JOB_FORMS}
        primaryButtonText={Strings.NEW_JOB}
        onNewClick={() => setAddJobDialog(true)}
        secondaryButtonClick={() => navigate('/app/jobs/forms')}
        filterButtonClick={() => setJobFilterDialog(true)}
        toolboxContainerClassName={classes.toolbox_container}
        startDateContainerClassName={classes.start_date_container}
        dateContainerClass={classes.dateContainerClass}
        isFilterDropdown={
          !isClient() && filterDropdownList.length ? true : false
        }
        filterDropdownValue={filterDropdownValue}
        filterDropdownList={filterDropdownList}
        onChangeFilterDropdown={(e) => {
          setFilterDropdownValue(e.target.value);
          handleFilterSelectionClick(e.target.value);
          // setFilter({});
        }}
        onEditClick={(value) =>
          setOpenEditFilterDialog({ show: true, ...value })
        }
      />
      {/* {isClient() && (
        <Tabs
          dataList={tabsArray}
          activeTab={activeTab}
          onChange={(value) => {
            setSearch('');
            setFilter(isAdmin() ? { showAllJob: false } : null);
            setStartDate(null);
            setEndDate(null);
            setActiveTab(value);
            setFilterDropdownValue('0');
            if (activeTab !== value) setOpenRows([]);
          }}
          containerClassName={classes.tab_container}
        />
      )} */}
      <div className={classes.list_container}>
        {props.jobListLoading ? (
          <div className={classes.flexView}>
            <CircularProgress
              style={{
                color: theme.palette.background_button,
              }}
            />
          </div>
        ) : (
          <>
            {jobData && jobData.jobs && jobData.jobs.length === 0 ? (
              <div className={classes.flexView}>
                <p className={classes.no_data_message}>
                  {Strings.NO_DATA_FOUND}
                </p>
              </div>
            ) : (
              <TableContainer className='dataTable'>
                <Table
                  className={classes.list_table}
                  aria-labelledby='tableTitle'
                >
                  <Hidden smDown>
                    <EnhancedTableHead
                      headCells={headCells()}
                      handleRequestSort={handleRequestSort}
                      order={order}
                      orderBy={orderBy}
                    />
                  </Hidden>
                  <TableBody>
                    {jobData &&
                      jobData.jobs &&
                      filteredJobs?.map((data, index) => {
                        const {
                          _id,
                          date,
                          type,
                          assignedMember,
                          status,
                          title,
                          reportStatus,
                          client,
                          property,
                          // clientName,
                          // clientEmail,
                          report,
                          ViewByClient,
                          jobForm,
                          // jobType,
                          startDate,
                          endDate,
                          jobStatus,
                          jobNotes,
                          createdBy,
                          attachments,
                          details,
                          appointments,
                        } = data;
                        return (
                          <>
                            <TableRow
                              id={data._id}
                              className={classes.row_style}
                              key={data._id + index}
                              sx={{ width: '100%' }}
                              onClick={() => {
                                if (isClient()) {
                                  onOpenRow(index);
                                } else {
                                  setSelectedJobId(_id);
                                  !isClient() && setJobDetailDialog(true);
                                }
                              }}
                            >
                              <Hidden smUp>
                                <TableCell
                                  style={{
                                    ...tableCell(
                                      theme,
                                      openRows.includes(index)
                                    ),
                                    cursor: cursor,
                                    paddingLeft: 14,
                                    paddingRight: 0,
                                  }}
                                  component='td'
                                  scope='row'
                                  // onClick={() => {
                                  //   setSelectedJobId(_id);
                                  //   !isClient() && setJobDetailDialog(true);
                                  // }}
                                >
                                  <Stack
                                    // paddingTop={2.5}
                                    direction='row'
                                    alignItems='center'
                                  >
                                    <img
                                      className={classes.toggle_arrow}
                                      src={
                                        openRows.includes(index)
                                          ? icons(theme).downArrow
                                          : icons(theme).rightArrow
                                      }
                                      alt=''
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        onOpenRow(index);
                                      }}
                                    />
                                    <Stack direction='column'>
                                      <label
                                        className={classes.name_cell}
                                        style={{
                                          cursor: cursor,
                                        }}
                                      >
                                        {title}
                                      </label>
                                      <Stack
                                        paddingTop={1.5}
                                        direction='row'
                                        alignItems='center'
                                      >
                                        <label
                                          className={classes.common_cell}
                                          style={{ cursor: cursor }}
                                        >
                                          {report?.conductedOn
                                            ? moment(report.conductedOn).format(
                                                'MMM DD, YYYY'
                                              )
                                            : '-'}
                                        </label>

                                        <label
                                          className={classNames(
                                            classes.common_cell,
                                            classes.status_container
                                          )}
                                          style={{
                                            cursor: cursor,
                                            backgroundColor:
                                              statusColor(jobStatus),
                                          }}
                                        >
                                          {jobStatus}
                                        </label>
                                      </Stack>
                                    </Stack>
                                  </Stack>
                                </TableCell>
                              </Hidden>
                              <Hidden smDown>
                                <TableCell
                                  style={{
                                    ...tableCell(
                                      theme,
                                      openRows.includes(index)
                                    ),
                                    cursor: cursor,
                                  }}
                                  component='td'
                                  scope='row'
                                  // onClick={() => {
                                  //   setSelectedJobId(_id);
                                  //   !isClient() && setJobDetailDialog(true);
                                  // }}
                                >
                                  <Stack
                                    paddingTop={2.5}
                                    direction='row'
                                    alignItems='center'
                                  >
                                    <img
                                      className={classes.toggle_arrow}
                                      src={
                                        openRows.includes(index)
                                          ? icons(theme).downArrow
                                          : icons(theme).rightArrow
                                      }
                                      alt=''
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        onOpenRow(index);
                                      }}
                                    />
                                    <label
                                      className={classes.name_cell}
                                      style={{
                                        cursor: cursor,
                                      }}
                                    >
                                      {title}
                                    </label>
                                  </Stack>
                                </TableCell>
                                <TableCell
                                  style={{
                                    ...tableCell(
                                      theme,
                                      openRows.includes(index)
                                    ),
                                    cursor: cursor,
                                  }}
                                  component='td'
                                  scope='row'
                                  // onClick={() => {
                                  //   setSelectedJobId(_id);
                                  //   !isClient() && setJobDetailDialog(true);
                                  // }}
                                >
                                  <Stack
                                    paddingTop={2.5}
                                    direction='column'
                                    alignItems='flex-start'
                                  >
                                    <label
                                      className={classes.common_cell}
                                      style={{ cursor: cursor }}
                                    >
                                      {property?.name || '-'}
                                    </label>
                                  </Stack>
                                </TableCell>
                                {!isClient() && (
                                  <TableCell
                                    style={{
                                      ...tableCell(
                                        theme,
                                        openRows.includes(index)
                                      ),
                                      cursor: cursor,
                                    }}
                                    component='td'
                                    scope='row'
                                    // onClick={() => {
                                    //   setSelectedJobId(_id);
                                    //   !isClient() && setJobDetailDialog(true);
                                    // }}
                                  >
                                    <Stack
                                      paddingTop={2.5}
                                      direction='column'
                                      alignItems='flex-start'
                                      style={{ minWidth: 80 }}
                                    >
                                      <label
                                        className={classes.common_cell}
                                        style={{ cursor: cursor }}
                                      >
                                        {moment(startDate).format(
                                          'MMM DD, YYYY hh:mm a'
                                        )}
                                      </label>
                                    </Stack>
                                  </TableCell>
                                )}
                                {!isClient() && (
                                  <TableCell
                                    style={{
                                      ...tableCell(
                                        theme,
                                        openRows.includes(index)
                                      ),
                                      cursor: cursor,
                                    }}
                                    component='td'
                                    scope='row'
                                  >
                                    <Stack
                                      paddingTop={2.5}
                                      direction='column'
                                      alignItems='flex-start'
                                      style={{ minWidth: 80 }}
                                    >
                                      <label
                                        className={classes.common_cell}
                                        style={{ cursor: cursor }}
                                      >
                                        {getDuration(startDate, endDate)}
                                      </label>
                                    </Stack>
                                  </TableCell>
                                )}

                                {!isClient() && (
                                  <TableCell
                                    style={{
                                      ...tableCell(
                                        theme,
                                        openRows.includes(index)
                                      ),
                                      cursor: cursor,
                                    }}
                                    component='td'
                                    scope='row'
                                    // onClick={() => {
                                    //   setSelectedJobId(_id);
                                    //   !isClient() && setJobDetailDialog(true);
                                    // }}
                                  >
                                    <Stack
                                      paddingTop={2.5}
                                      direction='column'
                                      alignItems='flex-start'
                                    >
                                      <label
                                        className={classes.common_cell}
                                        style={{ cursor: cursor }}
                                      >
                                        {jobForm &&
                                          jobForm.formName &&
                                          jobForm.formName}
                                      </label>
                                    </Stack>
                                  </TableCell>
                                )}
                                {!isClient() && (
                                  <TableCell
                                    style={{
                                      ...tableCell(
                                        theme,
                                        openRows.includes(index)
                                      ),
                                      cursor: cursor,
                                    }}
                                    component='td'
                                    scope='row'
                                  >
                                    <Stack
                                      paddingTop={2.5}
                                      direction='column'
                                      alignItems='flex-start'
                                    >
                                      <label
                                        className={classes.common_cell}
                                        style={{ cursor: cursor }}
                                      >
                                        {assignedMember?.name}
                                      </label>
                                      {/* <AvatarGroup
                                      sx={{
                                        '& .MuiAvatar-root': {
                                          width: 24,
                                          height: 24,
                                          fontFamily: "'Open Sans', sans-serif",
                                          fontSize: 14,
                                          fontWeight: 400,
                                          border: `1px solid ${theme.palette.background_button_text}`,
                                          color: theme.palette.profile_title,
                                          backgroundColor:
                                            theme.palette.avatar_background,
                                        },
                                      }}
                                      spacing={5}
                                      max={3}
                                    >
                                      <Avatar
                                        className={classNames(
                                          classes.common_cell
                                        )}
                                        alt={assignedMember?.name}
                                        src=''
                                        style={{
                                          backgroundColor:
                                            theme.palette.avatar_background,
                                          padding: 2,
                                        }}
                                      >
                                        {getFirstTwoLetter(
                                          assignedMember?.name
                                        )}
                                      </Avatar>
                                    </AvatarGroup> */}
                                    </Stack>
                                  </TableCell>
                                )}
                                {isClient() && (
                                  <TableCell
                                    style={{
                                      ...tableCell(
                                        theme,
                                        openRows.includes(index)
                                      ),
                                      cursor: cursor,
                                    }}
                                    component='td'
                                    scope='row'
                                  >
                                    <Stack
                                      paddingTop={2.5}
                                      direction='column'
                                      alignItems='flex-start'
                                    >
                                      <AvatarGroup
                                        sx={{
                                          '& .MuiAvatar-root': {
                                            width: 32,
                                            height: 32,
                                            fontFamily:
                                              "'Open Sans', sans-serif",
                                            fontSize: 14,
                                            fontWeight: 400,
                                            border: `1px solid ${theme.palette.background_button_text}`,
                                            color: theme.palette.profile_title,
                                            backgroundColor:
                                              theme.palette.avatar_background,
                                          },
                                        }}
                                        spacing={5}
                                        max={3}
                                      >
                                        {assignedMember?.map((i, ind) => (
                                          <Avatar
                                            className={classNames(
                                              classes.common_cell
                                            )}
                                            alt={i.name}
                                            src=''
                                            style={{
                                              backgroundColor:
                                                theme.palette.avatar_background,
                                            }}
                                            key={i.name + ind}
                                          >
                                            {assignedInitial(i.name)}
                                          </Avatar>
                                        ))}
                                      </AvatarGroup>
                                    </Stack>
                                  </TableCell>
                                )}

                                {isClient() && (
                                  <TableCell
                                    style={{
                                      ...tableCell(
                                        theme,
                                        openRows.includes(index)
                                      ),
                                      cursor: cursor,
                                    }}
                                    component='td'
                                    scope='row'
                                  >
                                    <Stack
                                      paddingTop={2.5}
                                      direction='column'
                                      alignItems='flex-start'
                                    >
                                      <label
                                        className={classes.common_cell}
                                        style={{ cursor: cursor }}
                                      >
                                        {report?.conductedOn
                                          ? moment(report.conductedOn).format(
                                              'MMM DD, YYYY'
                                            )
                                          : '-'}
                                      </label>
                                    </Stack>
                                  </TableCell>
                                )}

                                <TableCell
                                  style={{
                                    ...tableCell(
                                      theme,
                                      openRows.includes(index)
                                    ),
                                    cursor: cursor,
                                  }}
                                  component='td'
                                  scope='row'
                                  // onClick={() => {
                                  //   setSelectedJobId(_id);
                                  //   !isClient() && setJobDetailDialog(true);
                                  // }}
                                >
                                  <Stack
                                    paddingTop={2.5}
                                    direction='column'
                                    alignItems='flex-start'
                                  >
                                    <label
                                      className={classNames(
                                        classes.common_cell,
                                        classes.status_container
                                      )}
                                      style={{
                                        cursor: cursor,
                                        backgroundColor: statusColor(jobStatus),
                                      }}
                                    >
                                      {jobStatus}
                                    </label>
                                  </Stack>
                                </TableCell>

                                {/* {!isClient() && (
                                  <TableCell
                                    style={{
                                      ...tableCell(
                                        theme,
                                        openRows.includes(index)
                                      ),
                                      cursor: cursor,
                                    }}
                                    component='td'
                                    scope='row'
                                    // onClick={() => {
                                    //   setSelectedJobId(_id);
                                    //   !isClient() && setJobDetailDialog(true);
                                    // }}
                                  >
                                    <Stack
                                      paddingTop={2.5}
                                      direction='column'
                                      alignItems='flex-start'
                                    >
                                      <label
                                        className={classes.common_cell}
                                        style={{ cursor: cursor }}
                                      >
                                        {client?.lastName || '-'}
                                      </label>
                                    </Stack>
                                  </TableCell>
                                )} */}
                              </Hidden>
                              {isClient() && (
                                <>
                                  <TableCell
                                    style={{
                                      ...tableCell(
                                        theme,
                                        openRows.includes(index)
                                      ),
                                      cursor: cursor,
                                    }}
                                    component='td'
                                    scope='row'
                                    // onClick={() => {
                                    //   setSelectedJobId(_id);
                                    //   !isClient() && setJobDetailDialog(true);
                                    // }}
                                  >
                                    <Stack
                                      // paddingTop={2.5}
                                      direction='column'
                                      alignItems='flex-start'
                                      className={classes.report_action_stack}
                                    >
                                      <Button
                                        text={Strings.VIEW_REPORT}
                                        // containerClassName={
                                        //   classes.report_btn_container
                                        // }
                                        className={classes.report_button}
                                        disabled={!report}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          report &&
                                            navigate('/app/report', {
                                              state: {
                                                jobId: _id,
                                              },
                                            });
                                        }}
                                      />
                                    </Stack>
                                  </TableCell>
                                  <Hidden smDown>
                                    <TableCell
                                      style={{
                                        ...tableCell(
                                          theme,
                                          openRows.includes(index)
                                        ),
                                      }}
                                      component='td'
                                      scope='row'
                                      align='right'
                                    >
                                      <Stack
                                        paddingTop={2.5}
                                        direction='row'
                                        alignItems='center'
                                        justifyContent='end'
                                      >
                                        <CustomizedTooltips
                                          title={Strings.ADD_NOTE}
                                        >
                                          <img
                                            className={classes.action_icons}
                                            src={icons(theme).addNote}
                                            alt=''
                                            onClick={(e) => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                              setSelectedJobId(_id);
                                              setAddNoteDialog(true);
                                            }}
                                          />
                                        </CustomizedTooltips>
                                      </Stack>
                                    </TableCell>
                                  </Hidden>
                                  <Hidden smUp>
                                    <TableCell
                                      style={{
                                        ...tableCell(
                                          theme,
                                          openRows.includes(index)
                                        ),
                                      }}
                                      component='td'
                                      scope='row'
                                      align='right'
                                    >
                                      <Stack
                                        direction='row'
                                        alignItems='center'
                                        justifyContent='end'
                                      >
                                        <CustomizedTooltips
                                          title={Strings.ADD_NOTE}
                                        >
                                          <img
                                            className={classes.action_icons}
                                            src={icons(theme).addNote}
                                            alt=''
                                            onClick={(e) => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                              setSelectedJobId(_id);
                                              setAddNoteDialog(true);
                                            }}
                                          />
                                        </CustomizedTooltips>
                                      </Stack>
                                    </TableCell>
                                  </Hidden>
                                </>
                              )}
                              {!isClient() && (
                                <>
                                  {/* <TableCell
                                    style={{
                                      ...tableCell(
                                        theme,
                                        openRows.includes(index),
                                      ),
                                      cursor: cursor,
                                    }}
                                    component='td'
                                    scope='row'
                                    // onClick={() => {
                                    //   setSelectedJobId(_id);
                                    //   !isClient() && setJobDetailDialog(true);
                                    // }}
                                  >
                                    <Stack
                                      paddingTop={2.5}
                                      direction='column'
                                      alignItems='flex-start'
                                    >
                                      <label
                                        className={classes.common_cell}
                                        style={{ cursor: cursor }}
                                      >
                                        {ViewByClient
                                          ? `on ${moment(ViewByClient).format(
                                              'DD MMM YYYY',
                                            )}`
                                          : '-'}
                                      </label>
                                    </Stack>
                                  </TableCell> */}
                                  <TableCell
                                    style={{
                                      ...tableCell(
                                        theme,
                                        openRows.includes(index)
                                      ),
                                    }}
                                    component='td'
                                    scope='row'
                                    align='right'
                                  >
                                    <Stack
                                      paddingTop={2.5}
                                      direction='row'
                                      alignItems='center'
                                      justifyContent='end'
                                      style={{ minWidth: 142 }}
                                    >
                                      <CustomizedTooltips
                                        title={Strings.EDIT_JOB}
                                      >
                                        <img
                                          className={classNames(
                                            classes.action_icons,
                                            classes.action_visible
                                          )}
                                          src={icons(theme).editIcon}
                                          alt=''
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setIsEdit(true);
                                            setSelectedJob(data);
                                            setAddJobDialog(true);
                                          }}
                                        />
                                      </CustomizedTooltips>
                                      <CustomizedTooltips
                                        title={Strings.DELETEJOB}
                                      >
                                        <img
                                          className={classNames(
                                            classes.action_icons,
                                            classes.action_visible
                                          )}
                                          style={{ marginLeft: 15 }}
                                          src={icons(theme).deleteIcon}
                                          alt=''
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setSelectedJob(data);
                                            setDeleteJobDialog(true);
                                          }}
                                        />
                                      </CustomizedTooltips>
                                      <CustomizedTooltips
                                        title={
                                          report ? Strings.VIEW_REPORT : ''
                                        }
                                      >
                                        <img
                                          className={classes.action_icons}
                                          style={{ marginLeft: 15 }}
                                          src={
                                            report && reportStatus
                                              ? icons(theme).chartIcon
                                              : icons(theme).chartIconDisable
                                          }
                                          alt=''
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            report &&
                                              navigate('/app/report', {
                                                state: {
                                                  jobId: _id,
                                                },
                                              });
                                          }}
                                        />
                                      </CustomizedTooltips>
                                      <CustomizedTooltips
                                        title={Strings.ADD_NOTE}
                                      >
                                        <img
                                          className={classes.action_icons}
                                          style={{ marginLeft: 15 }}
                                          src={icons(theme).addNote}
                                          alt=''
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setSelectedJobId(_id);
                                            setAddNoteDialog(true);
                                          }}
                                        />
                                      </CustomizedTooltips>
                                    </Stack>
                                  </TableCell>
                                </>
                              )}
                            </TableRow>
                            {openRows.includes(index) && (
                              <>
                                {/* {!isClient() && (
                                  <TableRow
                                    key={data._id}
                                    sx={{ width: '100%' }}
                                  >
                                    <TableCell
                                      style={{
                                        ...secondaryTableCell(theme, false),
                                      }}
                                      component='td'
                                      scope='row'
                                      colSpan={9}
                                    >
                                      <div
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'row',
                                          marginBottom: 10,
                                          alignItens: 'center',
                                          // justifyContent: 'space-between'
                                        }}
                                      >
                                        <label
                                          className={classes.common_cell}
                                          style={{
                                            cursor: cursor,
                                            width: '25%',
                                            fontFamily:
                                              "'Open Sans', sans-serif",
                                            fontWeight: 600,
                                            fontSize: 12,
                                            color: theme.palette.menu_indicator,
                                          }}
                                        >
                                          {Strings.START_DATE_TIME.toUpperCase()}
                                        </label>
                                        <label
                                          className={classes.common_cell}
                                          style={{
                                            cursor: cursor,
                                            width: '25%',
                                            fontFamily:
                                              "'Open Sans', sans-serif",
                                            fontWeight: 600,
                                            fontSize: 12,
                                            color: theme.palette.menu_indicator,
                                          }}
                                        >
                                          {Strings.END_DATE_TIME.toUpperCase()}
                                        </label>
                                        <label
                                          className={classes.common_cell}
                                          style={{
                                            cursor: cursor,
                                            width: '25%',
                                            fontFamily:
                                              "'Open Sans', sans-serif",
                                            fontWeight: 600,
                                            fontSize: 12,
                                            color: theme.palette.menu_indicator,
                                          }}
                                        >
                                          {'ASSIGNED'}
                                        </label>
                                      </div>

                                      {appointments?.map((item, ind) => {
                                        return (
                                          <div
                                            style={{
                                              display: 'flex',
                                              flexDirection: 'row',
                                              marginBottom: 10,
                                              alignItens: 'center',
                                              // justifyContent: 'space-between'
                                            }}
                                            key={item.title + ind}
                                          >
                                            <label
                                              className={classes.common_cell}
                                              style={{
                                                cursor: cursor,
                                                width: '25%',
                                                display: 'flex',
                                                alignItems: 'center',
                                              }}
                                            >
                                              {moment(item.startDate).format(
                                                ' MMM D, YYYY hh:mm a'
                                              )}
                                            </label>

                                            <label
                                              className={classes.common_cell}
                                              style={{
                                                cursor: cursor,
                                                width: '25%',
                                                display: 'flex',
                                                alignItems: 'center',
                                              }}
                                            >
                                              {moment(item.endDate).format(
                                                'MMM D, YYYY hh:mm a'
                                              )}
                                            </label>

                                            <AvatarGroup
                                              sx={{
                                                '& .MuiAvatar-root': {
                                                  width: 32,
                                                  height: 32,
                                                  fontFamily:
                                                    "'Open Sans', sans-serif",
                                                  fontSize: 14,
                                                  fontWeight: 400,
                                                  border: `1px solid ${theme.palette.background_button_text}`,
                                                  color:
                                                    theme.palette.profile_title,
                                                  backgroundColor:
                                                    theme.palette
                                                      .avatar_background,
                                                },
                                              }}
                                              spacing={5}
                                              max={3}
                                            >
                                              {item.assignedMember.map(
                                                (i, ind) => (
                                                  <Avatar
                                                    className={classNames(
                                                      classes.common_cell
                                                    )}
                                                    alt={i.name}
                                                    // src={item.profilePicture}
                                                    src=''
                                                    style={{
                                                      backgroundColor:
                                                        theme.palette
                                                          .avatar_background,
                                                    }}
                                                    key={i.name + ind}
                                                  >
                                                    {assignedInitial(i.name)}
                                                  </Avatar>
                                                )
                                              )}
                                            </AvatarGroup>
                                          </div>
                                        );
                                      })}
                                    </TableCell>
                                  </TableRow>
                                )} */}

                                <TableRow key={data._id} sx={{ width: '100%' }}>
                                  <TableCell
                                    style={{
                                      ...secondaryTableCell(theme, true),
                                    }}
                                    component='td'
                                    scope='row'
                                    colSpan={9}
                                  >
                                    <Stack flexDirection='column'>
                                      <Tabs
                                        underlineTabs
                                        noDataLength
                                        containerClassName={
                                          classes.job_details_container
                                        }
                                        tabClassName={classes.job_details_tab}
                                        dataList={jobsDetailTabArray(
                                          isClient()
                                        )}
                                        activeTab={detailsActiveTab[index]?.key}
                                        notesNotification={
                                          detailsActiveTab[index]
                                            ?.notesNotification
                                        }
                                        internalNotesNotification={
                                          detailsActiveTab[index]
                                            ?.internalNotesNotification
                                        }
                                        onChange={(value) => {
                                          let newTab = [...detailsActiveTab];
                                          const data = {
                                            type: value,
                                            jobId: _id,
                                          };
                                          if (
                                            !isClient() &&
                                            ((value === 'notes' &&
                                              newTab[index]
                                                .notesNotification) ||
                                              (value === 'internalNotes' &&
                                                newTab[index]
                                                  .internalNotesNotification))
                                          ) {
                                            props.markAllJobsNotesRead(
                                              data,
                                              onError
                                            );
                                          }
                                          newTab[index].key = value;
                                          if (value === 'notes')
                                            newTab[
                                              index
                                            ].notesNotification = false;
                                          if (value === 'internalNotes')
                                            newTab[
                                              index
                                            ].internalNotesNotification = false;
                                          setDetailsActiveTab(newTab);
                                        }}
                                        tabIndex={index}
                                      />
                                      {detailsActiveTab[index].key ===
                                        'details' && (
                                        <>
                                          {details && (
                                            <NotesDataList
                                              data={{ note: details }}
                                            />
                                          )}
                                          {createdBy && createdBy.name && (
                                            <NotesDataList
                                              data={`${Strings.REPORTED_BY} ${createdBy?.name}`}
                                              style={{ marginTop: 15 }}
                                            />
                                          )}
                                        </>
                                      )}
                                      {detailsActiveTab[index].key ===
                                        'notes' && (
                                        <>
                                          {jobNotes?.length > 0 &&
                                            jobNotes
                                              ?.filter(
                                                (item) => !item.internalNotes
                                              )
                                              .map((item, i) => (
                                                <NotesDataList
                                                  data={item}
                                                  isBottomBorder={
                                                    jobNotes?.length !== i + 1
                                                  }
                                                  onEditClick={() => {
                                                    setAddNoteDialog(true);
                                                    setIsEditNote(true);
                                                    setSelectedNoteData({
                                                      jobId: _id,
                                                      noteId: item?._id,
                                                      note: item?.note,
                                                      internalNotes:
                                                        item?.internalNotes,
                                                    });
                                                    setSelectedJobNoteId(
                                                      item?._id
                                                    );
                                                    setSelectedJobId(_id);
                                                  }}
                                                  deleteLoader={
                                                    selectedJobNoteId ===
                                                      item?._id &&
                                                    props?.deleteJobNoteLoading
                                                  }
                                                  onDeleteClick={() => {
                                                    setSelectedJobNoteId(
                                                      item?._id
                                                    );
                                                    onDeleteNoteClick(
                                                      _id,
                                                      item?._id
                                                    );
                                                  }}
                                                />
                                              ))}
                                        </>
                                      )}
                                      {detailsActiveTab[index].key ===
                                        'internalNotes' && (
                                        <>
                                          {jobNotes
                                            ?.filter(
                                              (item) => item.internalNotes
                                            )
                                            .map((item, index) => (
                                              <NotesDataList
                                                data={item}
                                                isBottomBorder={
                                                  jobNotes?.length !== index + 1
                                                }
                                                onEditClick={() => {
                                                  setAddNoteDialog(true);
                                                  setIsEditNote(true);
                                                  setSelectedNoteData({
                                                    jobId: _id,
                                                    noteId: item?._id,
                                                    note: item?.note,
                                                    internalNotes:
                                                      item?.internalNotes,
                                                  });
                                                  setSelectedJobNoteId(
                                                    item?._id
                                                  );
                                                  setSelectedJobId(_id);
                                                }}
                                                deleteLoader={
                                                  selectedJobNoteId ===
                                                    item?._id &&
                                                  props?.deleteJobNoteLoading
                                                }
                                                onDeleteClick={() => {
                                                  setSelectedJobNoteId(
                                                    item?._id
                                                  );
                                                  onDeleteNoteClick(
                                                    _id,
                                                    item?._id
                                                  );
                                                }}
                                              />
                                            ))}
                                        </>
                                      )}
                                      {detailsActiveTab[index]?.key ===
                                        'media' && (
                                        <>
                                          {attachments &&
                                            attachments.length > 0 && (
                                              <div>
                                                <MediaImageContainer
                                                  imageArray={attachments}
                                                  itemsPerRow={
                                                    mobileView
                                                      ? 2
                                                      : tabletView
                                                      ? 3
                                                      : laptopView
                                                      ? 4
                                                      : 5
                                                  }
                                                />
                                              </div>
                                            )}
                                        </>
                                      )}

                                      {/* {detailsActiveTab[index] ===
                                        'details' && (
                                        <>
                                          <NotesDataList data={description} />
                                          {images && images.length > 0 && (
                                            <div>
                                              <MediaImageContainer
                                                imageArray={images}
                                                // imageData={props?.imageData}
                                                itemsPerRow={
                                                  mobileView
                                                    ? 2
                                                    : tabletView
                                                    ? 3
                                                    : laptopView
                                                    ? 4
                                                    : 5
                                                }
                                              />
                                            </div>
                                          )}
                                          {createdBy && createdBy.name && (
                                            <NotesDataList
                                              data={`${Strings.REPORTED_BY} ${createdBy?.name}`}
                                              style={{ marginTop: 15 }}
                                            />
                                          )}
                                        </>
                                      )} */}
                                    </Stack>
                                  </TableCell>
                                </TableRow>
                              </>
                            )}
                          </>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </>
        )}
      </div>
      {addJobDialog && !isClient() && (
        <NewJob
          isEdit={isEdit}
          data={selectedJob}
          onNewClose={() => {
            setIsEdit(false);
            setAddJobDialog(false);
          }}
        />
      )}
      {jobDetailDialog && !isClient() && (
        <JobDetails
          onNewClose={() => setJobDetailDialog(false)}
          fetchJobId={selectedJobId}
        />
      )}
      {jobFilterDialog && !isClient() && (
        <JobFilter
          setFilterData={setFilterData}
          filterData={filter}
          setIsFilterChange={setIsFilterChange}
          onClose={() => setJobFilterDialog(false)}
          // isActiveTabToday={activeTab === 'Today'}
        />
      )}
      {/* {sendReportDialog && !isClient() && (
        <SendReport
          selectedJobId={selectedJobId}
          onNewClose={() => setSendReportDialog(false)}
          client={selectedJobClient}
          isReviewReport={true}
        />
      )} */}
      {deleteJobDialog && !isClient() && (
        <CommonDialog
          title={Strings.JOB}
          message={Strings.DELETE_JOB}
          onSuccess={() => onDeleteJob()}
          onClose={() => setDeleteJobDialog(false)}
          loading={props.deleteJobLoading}
        />
      )}
      {addNoteDialog && (
        <AddNotes
          isJob
          selectedId={selectedJobId}
          onNewClose={() => {
            setAddNoteDialog(false);
            setIsEditNote(false);
            setSelectedNoteData(null);
          }}
          isEditJobNote={isEditNote}
          selectedNoteData={selectedNoteData}
        />
      )}
      {openEditFilterDialog?.show && (
        <JobNewFilter
          isEdit={true}
          // isActiveTabToday={activeTab === 'Today'}
          selectedId={openEditFilterDialog?.value}
          setIsFilterChange={setIsFilterChange}
          onClose={() => setOpenEditFilterDialog(false)}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  jobListData: state.jobListData.data,
  jobListLoading: state.jobListData.loading,

  addJobData: state.addJobData.data,

  deleteJobLoading: state.deleteJobData.loading,
  deleteJobData: state.deleteJobData.data,

  updateJobData: state.updateJobData.data,

  updateRecurrenceData: state.updateRecurrence.data,
  cancelRecurrenceData: state.cancelRecurrence.data,

  sendReportData: state.sendReportData.data,

  addJobNoteData: state.addJobNoteData.data,

  updateJobNoteData: state.updateJobNoteData.data,

  deleteJobNoteLoading: state.deleteJobNoteData.loading,

  listFilterData: state.listFilterData.data,
  listFilterLoading: state.listFilterData.loading,

  addFilterData: state.addFilterData.data,
  updateFilterData: state.updateFilterData.data,
  deleteFilterData: state.deleteFilterData.data,
});

export default connect(mapStateToProps, {
  fetchJobList,
  deleteJob,
  updateRecurrence,
  cancelRecurrence,
  deleteJobNote,
  listFilter,
  markAllJobsNotesRead,
})(Jobs);
